import { isTaakAfgerond } from './projectMeta';
import {
  Box,
  Typography,
} from '@mui/material';
import { T, Icon, stitchPill } from './stitch';
import { taskTypeColors, formatDate } from './projectMeta';
import { useProjectDataOptioneel } from '../ProjectDataContext';
import { draaidagTaakWeergave } from '../../../utils/draaidagTaak';


// Priority colors
const prioColors = {
  'Prio 1': '#ef4444',
  'Prio 2': '#f59e0b',
  'Prio 3': '#3b82f6',
  'Deadline': '#dc2626',
  'Opgestuurd': '#10b981',
};


// Task Item Component
function TaskItem({ task, compact = false, onClick, onToggleComplete, draaidagen: draaidagenProp }) {
  // Draaidagtaak: crew van de gekoppelde draaidag i.p.v. de (mogelijk verouderde) taaknaam en
  // uitvoerder — externe crew staat alleen in de Outlook-titel (9604, 23 okt 2026).
  const ctx = useProjectDataOptioneel();
  const dd = draaidagTaakWeergave(task, draaidagenProp || ctx?.draaidagen);
  const name = task.fields?.NaamTaak || '-';
  const displayName = dd ? dd.naam : name;
  // Use Voornaam Assignee lookup if available
  const assigneeNames = task.fields?.['Voornaam Assignee'] || task.fields?.Assignee || [];
  const assignee = dd ? '' : Array.isArray(assigneeNames)
    ? assigneeNames.filter(n => n && !String(n).startsWith('rec')).join(', ')
    : (assigneeNames && !String(assigneeNames).startsWith('rec') ? assigneeNames : '');
  const startDate = formatDate(task.fields?.StartDateUitvoerder);
  const endDate = formatDate(task.fields?.EndDateUitvoerder || task.fields?.Deadline);
  const type = task.fields?.Type || '';
  const prio = task.fields?.PrioNr || '';
  const isComplete = isTaakAfgerond(task);

  // Format date range for display
  const dateRange = startDate && endDate
    ? (startDate === endDate ? startDate : `${startDate} - ${endDate}`)
    : (startDate || endDate || '');

  const handleCheckboxClick = (e) => {
    e.stopPropagation(); // Prevent triggering onClick (opening detail dialog)
    if (onToggleComplete) {
      onToggleComplete(task, !isComplete);
    }
  };

  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: compact ? 1.5 : 2,
        p: compact ? 1.5 : 2,
        borderRadius: '0.75rem',
        backgroundColor: isComplete ? T.surfaceLow : T.surface,
        border: `1px solid ${T.surfaceHigh}`,
        borderLeft: `3px solid ${taskTypeColors[type] || T.outlineVariant}`,
        boxShadow: T.shadow,
        transition: 'all 0.15s ease',
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': { borderColor: T.outlineVariant, backgroundColor: T.surfaceLow, boxShadow: '0 8px 24px rgba(45,51,53,0.08)', transform: 'translateY(-2px)' },
      }}
    >
      <Box
        onClick={handleCheckboxClick}
        sx={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          '&:hover': { transform: 'scale(1.1)' },
          transition: 'transform 0.1s ease',
        }}
      >
        {isComplete ? (
          <Icon name="check_circle" size={compact ? 18 : 20} sx={{ color: T.emerald }} />
        ) : (
          <Icon name="radio_button_unchecked" size={compact ? 18 : 20} sx={{ color: T.outlineVariant, '&:hover': { color: T.emerald } }} />
        )}
      </Box>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          variant={compact ? "body2" : "body2"}
          sx={{
            fontFamily: T.fontBody,
            fontWeight: 500,
            fontSize: compact ? '0.85rem' : undefined,
            color: isComplete ? T.outlineVariant : T.text,
            textDecoration: isComplete ? 'line-through' : 'none',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
          title={dd ? dd.titel : undefined}
        >
          {displayName}
        </Typography>
        {assignee && !compact && (
          <Typography variant="caption" sx={{ fontFamily: T.fontBody, color: T.outline }}>
            <Icon name="person" size={12} sx={{ verticalAlign: 'middle', marginRight: 2 }} /> {assignee}
          </Typography>
        )}
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 }}>
        {prio && (
          <Typography component="span" sx={stitchPill('#fff', prioColors[prio] || '#6b7280')}>
            {compact ? prio.replace('Prio ', 'P') : prio}
          </Typography>
        )}
        {type && !compact && (
          <Typography component="span" sx={{
            ...stitchPill(taskTypeColors[type] || T.outline, 'transparent'),
            border: `1px solid ${taskTypeColors[type] || T.outlineVariant}`,
          }}>
            {type}
          </Typography>
        )}
        {dateRange && (
          <Typography variant="caption" sx={{ fontFamily: T.fontBody, color: T.outline, display: 'flex', alignItems: 'center', gap: 0.5, fontSize: compact ? '0.7rem' : undefined }}>
            <Icon name="calendar_today" size={compact ? 10 : 12} />
            {dateRange}
          </Typography>
        )}
        {assignee && compact && (
          <Typography variant="caption" sx={{ fontFamily: T.fontBody, color: T.outline, fontSize: '0.7rem' }}>
            <Icon name="person" size={10} sx={{ verticalAlign: 'middle', marginRight: 2 }} /> {assignee.split(',')[0]}
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export default TaskItem;
